export default "__VITE_ASSET__1dc263c9__"